import { jsx as _jsx } from "react/jsx-runtime";
import { flattenError } from './flattenError';
/** Renders lists of errors or lists of strings */
export const ErrorContentFromArray = ({ errorList, }) => {
    if (!errorList || errorList.length === 0) {
        return null;
    }
    if (errorList.length === 1) {
        return _jsx("p", { children: flattenError(errorList[0]) });
    }
    return _jsx("ul", { children: errorList === null || errorList === void 0 ? void 0 : errorList.map(makeErrorListLi) });
};
/** Create an HTML li element from an error or string */
const makeErrorListLi = (error) => {
    const message = flattenError(error);
    if (!message)
        return null;
    return _jsx("li", { children: message }, `error list ${message}`);
};
